import moment from "moment";

(function (w) {
  const requiredElementSelector = '#maternity-leave-calculate';
  const requiredElement = document.querySelector(requiredElementSelector);

  if (!requiredElement) {
    return;
  }
  let minZP;
  const averageMonthDaysCount = 30.44;
  let minZPToDay = minZP / averageMonthDaysCount;
  let doubleMinZPToDay = minZPToDay * 2;
  let fifteenMinZPToDay = (minZP * 15) / averageMonthDaysCount;
  const dateInput = document.querySelector('input[name="startMaternityLeave"]');

  if (dateInput) {
    refreshSalary(dateInput.value);
  }

  const mainContainer = document.querySelector("#maternity-leave-calculate");
  if (mainContainer) {
    mainContainer.addEventListener("keyup", (event) => {
      const target = event.target;
      if (
          target.matches("input[name='tariffRate'], input[name='totalIncome'], input[name='sikPaymentsInPeriod']")
      ) {
        const inputVal = target.value;
        const matchResult = inputVal.match(/(\d+([.,]{1})?([0-9]{1,2})?)/g);
        if (matchResult) {
          target.value = matchResult[0];
        } else {
          target.value = '';
        }
      }
    });
  }

  function refreshSalary(date) {
    fetch(`/nsl-calculator/get-min-salary?date_from=${date}&date_to=${date}`)
        .then((response) => response.json())
        .then((res) => {
          if (!res || !res[0]) return;
          minZP = res[0].min_salary;
          minZPToDay = minZP / averageMonthDaysCount;
          doubleMinZPToDay = minZPToDay * 2;
          fifteenMinZPToDay = (minZP * res[0].esv_rate) / averageMonthDaysCount;
        })
        .catch(() => {});
  }

  function isLeap(year) {
    return new Date(year, 1, 29).getDate() === 29;
  }

  function priceFormat(text) {
    text = text.toFixed(2).replace(/./g, function (c, i, a) {
      return i && c !== "." && ((a.length - i) % 3 === 0) ? ' ' + c : c;
    });
    return text;
  }

  function MaternityLeave(options) {
    window.uteka.Base.call(this, options);

    this.state = Object.assign({}, this.state || {}, {
      data: {
        startMaternityLeave: null,
        startWork: null,
        diffDays: null,
        diffMonth: null,
        diffMonthSelected: null,
        daysInYear: null,
        duration: null,
        tariffRate: null,
        period: null,
        totalToPay: null,
        notWorkingDays: null,
        totalIncome: null,
        isLeap: null,
        middleDayIncome: null,
        daysForCalculateAverageDailySalary: null
      },
      isValid: true
    });

    if (this.elements.mainEl && this.elements.mainEl instanceof HTMLElement) {
      this
          .createEvents()
          .collectData()
          .processData()
          .doCalculation()
          .setResults();
    }
  }

  MaternityLeave.prototype = Object.create(w.uteka.Base.prototype);

  MaternityLeave.prototype.constructor = MaternityLeave;

  MaternityLeave.prototype.defaultOptions = {
    elements: {
      main: '#maternity-leave-calculate',
      fields: 'input[type="text"], input[type="number"], .js--select_period, .js--select_duration, .js--select_experience-2',
      calculate: '.js-maternity-leave-submit',
      period: '.js-calendar-days-period',
      daysForMiddlePay: '.js-calendar-days-for-middle-pay',
      middleDayIncome: '.js-middle-day-income',
      totalToPay: '.js-total-to-pay',
      periodField: '.js--select_period',
      totalIncome: 'input[name="totalIncome"]',
      notWorkingDays: 'input[type="number"][name="notWorkingDays"]'
    },
    events: {
      init: function () {
      }
    },
    isDebug: true,
    regexp: {
      date: /^\d{2}\/\d{2}\/\d{4}$/,
      date2: /^\d{2}\.\d{2}\.\d{4}$/
    }
  };


  MaternityLeave.prototype.log = function () {
    if (this.options.isDebug) {
      console.log.apply(console, arguments);
    }
    return this;
  };
  MaternityLeave.prototype.collectData = function () {
    var self = this;
    // console.log('MaternityLeave.prototype.collectData');
    // console.log(this.elements.fieldsEl);
    if (this.elements.fieldsEl) {
      this.elements.fieldsEl.forEach((el) => {
        const name = el.name;
        const val = el.value;

        if (name) {
          const isDatepicker = el.classList.contains('datapicker');
          const parsedVal = isDatepicker ? this.convertDate(val) : parseInt(val || 0);
          this.updateData(name, parsedVal);
        }
      });
    }

    return this;
  };

  MaternityLeave.prototype.processData = function () {
    // console.log('MaternityLeave.prototype.processData');
    const self = this;
    const period = this.getData('period');
    const diffMonth = this.getData('diffMonth');
    const daysInYear = this.getData('isLeap') ? 366 : 365;

    this.updateData('daysInYear', daysInYear);
    this.updateData('notWorkingDays', 0);

    return this;
  };

  MaternityLeave.prototype.updateData = function (key, val) {
    // console.log('MaternityLeave.prototype.updateData');
    this.log('updateData: key', key, ', val', val);
    if (this.options.regexp.date2.test(val)) {
      val = this.convertDate(val);
    }
    if (this.options.regexp.date.test(val)) {
      this.log(val);
      val = moment(val);
    }
    switch (key) {
      case 'duration':
      case 'insurancePeriod':
        val = parseInt(val);
        break;
      case 'tariffRate':
        var tariffRateVal = val.toString().replace(/,/, ".");
        val = parseFloat(tariffRateVal);
        break;
      case 'totalIncome':
        var totalIncomeVal = val.toString().replace(/,/, ".");
        val = parseFloat(totalIncomeVal);
        break;
      case 'sikPaymentsInPeriod':
        var sikPaymentsInPeriodVal = val.toString().replace(/,/, ".");
        val = parseFloat(sikPaymentsInPeriodVal);
        break;
    }
    this.state.data[key] = val;
    return this;
  };

  MaternityLeave.prototype.getData = function (key) {
    return this.state.data[key] || false;
  };

  MaternityLeave.prototype.convertDate = function (dateStr) {
    dateStr = dateStr.split('.');

    return dateStr[1] + '/' + dateStr[0] + '/' + dateStr[2];
  };

  MaternityLeave.prototype.doCalculation = function () {
    // console.log('MaternityLeave.prototype.doCalculation');
    let diffDays = 0, i = 0;
    let diffMonth = 0;
    let diffMonthSelected = 0;
    let ifZeroDays = false;
    let period = this.getData('period').toString(),
        duration = this.getData('duration'),
        startWork = this.getData('startWork'),
        daysInYear = this.getData('daysInYear'),
        tariffRate = this.getData('tariffRate'),
        totalIncome = this.getData('totalIncome'),
        notWorkingDays = this.getData('notWorkingDays'),
        insurancePeriod = this.getData('insurancePeriod'),
        middleDayIncome = this.getData('middleDayIncome'),
        sikPaymentsInPeriod = this.getData('sikPaymentsInPeriod'),
        startMaternityLeave = this.getData('startMaternityLeave');
    let prevMonth, periodStart, daysForCalculateAverageDailySalary;

    this.log('period on do calculation', period);


    if (startMaternityLeave && startWork) {

      diffMonth = this.calculateDiffMonth(startWork, startMaternityLeave);
      diffMonth = diffMonth > 12 ? 12 : diffMonth;
      this.updateData('diffMonth', diffMonth);

      this.updateData('isLeap', isLeap(startMaternityLeave.year()));

      /* calculate diff days */
      if (period !== null) {
        switch (period) {
          case '12':
            diffMonth = 12;
            prevMonth = startMaternityLeave.clone();
            for (let i = 0; i < diffMonth; i++) {
              diffDays += prevMonth.subtract(1, 'month').daysInMonth();
              // console.log(diffDays);
            }
            break;
          case '<12':
            diffMonth = diffMonth > 11 ? 11 : diffMonth;
            prevMonth = startMaternityLeave.clone();
            for (i = 0; i < diffMonth; i++) {
              diffDays += prevMonth.subtract(1, 'month').daysInMonth();
            }
            break;
          case '<1':
            diffMonth = 0;
            diffDays = this.calculateDiffDays(
                startWork,
                startMaternityLeave
            );

            diffDays = diffDays > startWork.daysInMonth() ? startWork.daysInMonth() - 1 : diffDays;

            break;
          case '0':
            diffDays = this.getData('isLeap') ? 366 : 365;
            diffMonth = 0;
            if (tariffRate) {
              this.updateData('totalIncome', tariffRate * 12)
            }
            break;
        }
        diffMonthSelected = diffMonth;
        this.updateData('diffMonthSelected', diffMonthSelected);

        if (diffDays) {
          this.updateData(
              'diffDays',
              diffDays
          );
          this.log('notWorkingDays', notWorkingDays);
          if (notWorkingDays !== null) {
            daysForCalculateAverageDailySalary = diffDays - notWorkingDays;
            if (daysForCalculateAverageDailySalary <= 0) {
              daysForCalculateAverageDailySalary = daysInYear;
              ifZeroDays = true;

            }
            this.log('daysForCalculateAverageDailySalary', daysForCalculateAverageDailySalary);
            this.updateData('daysForCalculateAverageDailySalary', daysForCalculateAverageDailySalary);
          }
          if (tariffRate !== null && period === '0') {
            if (period === '0' || ifZeroDays) {
              totalIncome = tariffRate * 12;
              this.updateData('notWorkingDays', daysInYear)
                  .updateData('totalIncome', totalIncome);
            } else {
              if (notWorkingDays === 365 || notWorkingDays === 366) {
                notWorkingDays = 0;
                this.updateData('notWorkingDays', notWorkingDays)
                    .updateData('totalIncome', 0);
              }
            }
          }
          if (totalIncome || tariffRate) {
            if(!totalIncome) totalIncome = tariffRate * diffMonthSelected;
            if (sikPaymentsInPeriod !== null && daysForCalculateAverageDailySalary) {
              middleDayIncome = parseFloat(((totalIncome - sikPaymentsInPeriod) / daysForCalculateAverageDailySalary).toFixed(2));
              this.log('middleDayIncome', middleDayIncome);
              this.log('insurancePeriod', insurancePeriod);
              if (!insurancePeriod) {
                if (middleDayIncome < minZPToDay) {
                  middleDayIncome = minZPToDay
                } else if (middleDayIncome > doubleMinZPToDay) {
                  middleDayIncome = doubleMinZPToDay;
                }
              } else {
                if (middleDayIncome < minZPToDay) {
                  middleDayIncome = minZPToDay
                } else if (middleDayIncome > fifteenMinZPToDay) {
                  middleDayIncome = fifteenMinZPToDay;
                }
              }

              this.updateData('middleDayIncome', middleDayIncome);
            }
          }
        }


      }
      /* end calculate diff days */


    }


    return this;
  };
  MaternityLeave.prototype.doTotalCalculation = function () {
    let period = this.getData('period'),
        duration = this.getData('duration'),
        startWork = this.getData('startWork'),
        totalToPay = this.getData('totalToPay'),
        daysInYear = this.getData('daysInYear'),
        tariffRate = this.getData('tariffRate'),
        totalIncome = this.getData('totalIncome'),
        notWorkingDays = this.getData('notWorkingDays'),
        insurancePeriod = this.getData('insurancePeriod'),
        middleDayIncome = this.getData('middleDayIncome'),
        sikPaymentsInPeriod = this.getData('sikPaymentsInPeriod'),
        startMaternityLeave = this.getData('startMaternityLeave');


    if (middleDayIncome && duration) {
      totalToPay = middleDayIncome * duration;
      this.updateData('totalToPay', totalToPay);
    }
    return this;
  };

  MaternityLeave.prototype.setResults = function () {
    const self = this;
    const period = this.getData('period'),
        startWork = this.getData('startWork'),
        diffDays = this.getData('diffDays'),
        diffMonth = this.getData('diffMonth'),
        daysInYear = this.getData('daysInYear'),
        tariffRate = this.getData('tariffRate'),
        totalIncome = this.getData('totalIncome'),
        notWorkingDays = this.getData('notWorkingDays'),
        middleDayIncome = this.getData('middleDayIncome'),
        sikPaymentsInPeriod = this.getData('sikPaymentsInPeriod'),
        startMaternityLeave = this.getData('startMaternityLeave'),
        daysForCalculateAverageDailySalary = this.getData('daysForCalculateAverageDailySalary');
    let availablePeriod, checkedValue;

    if (this.state.data.diffDays !== null && this.elements.periodEl) {

      this.elements.periodEl.textContent = this.state.data.diffDays;
    }
    if (diffMonth !== null) {
      if (diffMonth >= 12) {
        availablePeriod = '12';
      }
      if (diffMonth < 12) {
        availablePeriod = '<12';
      }
      if (diffMonth < 1) {
        availablePeriod = '<1';
      }
      if (diffMonth === 0) {
        availablePeriod = '0';
      }

      if (period === '0') {
        if (this.elements.totalIncomeEl) {
          this.elements.totalIncomeEl.disabled = true;

          if (totalIncome) {
            this.elements.totalIncomeEl.value = totalIncome;
          }
        }
        if (this.elements.notWorkingDaysEl) {
          this.elements.notWorkingDaysEl.value = this.getData('daysInYear');
          this.elements.notWorkingDaysEl.disabled = true;
        }

      } else {
        if (this.elements.totalIncomeEl) {
          this.elements.totalIncomeEl.disabled = false;


        }
        if (this.elements.notWorkingDaysEl) {
          this.elements.notWorkingDaysEl.disabled = false;
        }
      }
      if (this.elements.periodFieldEl) {
        console.log('this.elements.periodFieldEl', this.elements.periodFieldEl);
        console.log('this.elements.periodFieldEl', this.elements.periodFieldEl.value);
        checkedValue = this.elements.periodFieldEl.value;

        const selectElement = this.elements.periodFieldEl;
        const choicesInstance = window.choicesSelects.find(instance => instance.passedElement.element === selectElement);
        if (choicesInstance) {
          const currentChoices = choicesInstance._currentState.choices;
          const updatedChoices = currentChoices.map(choice => {
            const val = choice.value;
            let disabled = false;

            switch (availablePeriod) {
              case '12':
                disabled = false; // Все варианты доступны
                break;
              case '<12':
                disabled = val === '12';
                break;
              case '<1':
                disabled = val === '12' || val === '<12';
                break;
              case '0':
                disabled = val === '12' || val === '<12' || val === '<1';
                break;
            }
            return { ...choice, disabled };
          });
          choicesInstance.setChoices(updatedChoices, 'value', 'label', true);

          const checkedChoice = updatedChoices.find(choice => choice.value === checkedValue);
          if (checkedChoice && checkedChoice.disabled) {
            this.log('Checked option disabled:', checkedChoice);
            const firstEnabled = updatedChoices.find(choice => !choice.disabled);
            if (firstEnabled) {
              choicesInstance.setChoiceByValue(firstEnabled.value);
              const changeEvent = new Event('change', { bubbles: true });
              this.elements.periodFieldEl.dispatchEvent(changeEvent);
            }
          }

        }

      }

    }
    if (daysForCalculateAverageDailySalary) {
      this.elements.daysForMiddlePayEl.textContent = daysForCalculateAverageDailySalary;
    } else {
      if (this.elements.daysForMiddlePayEl) {
        this.elements.daysForMiddlePayEl.textContent = 0;
      }
    }
    if (middleDayIncome) {
      this.elements.middleDayIncomeEl.textContent = priceFormat(middleDayIncome);
    } else {
      if (this.elements.middleDayIncomeEl) {
        this.elements.middleDayIncomeEl.textContent = 0;
      }
    }
    return this;
  };

  MaternityLeave.prototype.setTotalResults = function () {
    const totalToPay = this.getData('totalToPay');

    if (totalToPay) {
      this.elements.totalToPayEl.textContent = priceFormat(totalToPay);
    } else {
      if (this.elements.middleDayIncomeEl) {
        this.elements.totalToPayEl.textContent = 0;
      }
    }
    return this;
  };
  MaternityLeave.prototype.validateFields = function () {
    let valid = true;
    const fields = this.elements.mainEl.querySelectorAll(this.options.elements.fields);

    if (fields) {
      fields.forEach((field) => {
        if (!this.validateField(field)) {
          valid = false;
        }
      });
    }

    return valid;
  };

  MaternityLeave.prototype.validateField = function (field) {
    let valid = true;
    const name = field.name;
    const type = field.type;
    const val = field.value;
    const fieldContainer = field.closest('.field');
    const isDate = field.classList.contains('datapicker');
    const isDisabled = field.disabled;

    if (!isDisabled) {
      if (val) {
        switch (type) {
          case 'radio':
            break;
          case 'text':
            if (isDate) {
              if (!this.options.regexp.date2.test(val)) {
                valid = false;
              }
            }
            switch (name) {
              case '':
                break;
            }
            break;
          case 'number':
            break;
        }
      } else {
        switch (name) {
          case 'tariffRate':
            this.log('totalIncome', this.getData('totalIncome'));
            if (!this.getData('totalIncome')) {
              valid = false;
            }
            break;
          case 'totalIncome':
            this.log('totalIncome', this.getData('totalIncome'));
            if (!this.getData('tariffRate')) {
              valid = false;
            }
            break;
          case 'notWorkingDays':
            this.updateData('notWorkingDays', 0);
            break;
          case 'sikPaymentsInPeriod':
            this.updateData('sikPaymentsInPeriod', 0);
            break;
          default:
            valid = false;
            break;
        }
      }
    }

    if (fieldContainer) {
      fieldContainer.classList.toggle('invalid', !valid);
      field.classList.toggle('invalid', !valid);
    }

    return valid;
  };


  MaternityLeave.prototype.createEvents = function () {
    const self = this;

    if (this.elements.mainEl) {

      const fields = this.elements.mainEl.querySelectorAll(this.options.elements.fields);


      fields.forEach(function (field) {
        field.addEventListener('change', function (e) {
          const el = e.target;
          const name = el.name;
          const type = el.type;
          const value = el.value;

          if (name === 'startMaternityLeave') {
            refreshSalary(value);
          }

          const diffMonth = self.getData('diffMonth') || 0;
          let totalIncome = 0;

          self.log('validate field name', name);
          self.log('validate field value', value);

          if (self.validateField(el)) {
            const isDatepicker = el.classList.contains('datepicker');
            const parsedValue = isDatepicker
                ? self.convertDate(value)
                : (type === 'number' ? parseInt(value || 0) : value);

            self
                .updateData(name, parsedValue)
                .doCalculation()
                .setResults();
          }
        });

        field.addEventListener('blur', function () {
          self.validateField(field);
        });
      });
    }

    if (this.elements.calculateEl) {
      this.elements.calculateEl.addEventListener('click', function () {
        // console.log('calculate');
        if (self.validateFields()) {
          self
              .doTotalCalculation()
              .setTotalResults();

          console.log(self.state.data);
        }
      });
    }

    return this;
  };

  MaternityLeave.prototype.calculateDiffDays = function (date1, date2) {
    if (!moment.isMoment(date1)) {
      date1 = moment(
          this.options.regexp.date.test(date1)
              ? date1
              : this.convertDate(date1)
      );
    }
    if (!moment.isMoment(date2)) {
      date2 = moment(
          this.options.regexp.date.test(date2)
              ? date2
              : this.convertDate(date2)
      );
    }
    return date2.diff(date1, 'days');
  };

  MaternityLeave.prototype.calculateDiffMonth = function (date1, date2) {
    if (!moment.isMoment(date1)) {
      date1 = moment(
          this.options.regexp.date.test(date1)
              ? date1
              : this.convertDate(date1)
      );
    }
    if (!moment.isMoment(date2)) {
      date2 = moment(
          this.options.regexp.date.test(date2)
              ? date2
              : this.convertDate(date2)
      );
    }
    if(date1.date() !== 1){
      date1.add(1, 'month').date(1);
    }
    return date2.diff(date1, 'months');
  };

  w.uteka = w.uteka || {};
  w.uteka.MaternityLeave = MaternityLeave;


})(window);


document.addEventListener('DOMContentLoaded', function () {
  const maternityLeave = document.getElementById('maternity-leave-calculate');
  if (maternityLeave) {
    window.maternityLeave = new window.uteka.MaternityLeave({isDebug:false});
  }
});
